// 延迟发货类型
export enum DelayTypes {
    '商品无货'  = 1,
    '客户原因',
    '其他',
    '仓库疫情',
    '用户疫情'
}
// 延迟订单审核状态
export enum DelayStatus {
    '待审核',
    '审核通过',
    '已驳回' = 3
}
//申诉类型
export enum TypeStatus {
    '全部' = 0,
    '系统罚款',
    '人工罚款'
}
// 申诉订单商务审核状态
export enum AppealStatus {
    '审批中',
    '审批通过',
    '被驳回',
    '未提交'
}
// 申诉订单运营审核状态
export enum ExamineStatus {
    '待审核',
    '审核通过',
    '审核不通过'
}

// 订单配送类型
export enum ShipTypes {
    same        =   '快递配送',
    shop        =   '门店自提',
    delivery    =   '门店配送',
    stable      =   '统一配送'
}
// 订单状态
export enum OrderStatus {
    '待确认',   // 用户下单即为该状态
    '已分配',   // 商家已知晓，并进行了分配
    '已完成',   // 已完成：此时商户已上传快递号等信息；商家自配的会在已分配3天后自动改为该状态
    '已取消'    // 用户未支付取消了订单 或 完成了退款
}
// 订单细分状态
export enum OrderExpandStatus {
    '未分配',   // 此状态订单仅总商户可见
    '未发货',   // 订单为已分配状态，但没有物流信息
    '已发货',   // 已有物流信息
    '全部',     // 全部状态
    '已退款',   // 已完成退款（仅包含已支付订单，不包含未支付已取消订单）
    '未接单',   // 此状态仅门店账号可见，由总商户分配过来，但还未确认接单
}
// 确认接单状态
export enum OrderPickStatus {
    '未接单',       // 总商户和门店账号均未确认接单
    '门店账号接单', // 门店账号已点击确认接单
    '总商户接单',   // 总商户已点击确认接单
}

// 订单类型
export enum OrderType {
    '蛋糕' = 1,
    '面包',
    '零食小吃' = 5,
    '蛋糕DIY' = 7,
}
